import React from 'react'
import cv from '../../assets/samedakgul-cv.pdf'
import { ArrowIcon, Reveal, SplitReveal } from '../../components/motion'
import { CONTACT_MAILTO } from '../../components/Header'

const PRINCIPLES = [
    { n: "01", title: "Önce mobil", text: "React Native ve Flutter ile yerel hissettiren iOS ve Android uygulamaları. Mağaza yayını, uygulama içi satın alma, bildirim, analitik; hepsi dahil." },
    { n: "02", title: "Gerektiğinde tam yığın", text: "Node.js servisleri, veritabanı ve bulut kurulumu; uygulamanın konuşacağı sağlam bir arka uç. Web siteleri ve yönetim panelleri aynı elden." },
    { n: "03", title: "Kod değil, ürün", text: "Kendi uygulamalarım 135 binden fazla indirmeye ulaştı; bu yüzden ilk günden elde tutma, fiyatlandırma ve mağaza görünürlüğünü düşünürüm." },
    { n: "04", title: "Nasıl çalışırım", text: "Kısa döngüler, haftalık demolar, sade dille ilerleme notları. Ankara'dayım, dünyanın her yerine uzaktan çalışıyorum." },
];

const STACK = ["React Native", "Flutter", "Node.js", "TypeScript", "MongoDB", "PostgreSQL", "Firebase", "AWS", "Unity", "OpenAI API"];

function About() {
    return (
        <div className="bg-white">
            <section className="container-site pt-[48px] md:pt-[96px]">
                <h1 className="t-display max-w-[1000px]">
                    <SplitReveal text="Ürün sahibi gibi düşünen bir yazılım danışmanı" />
                </h1>
                <div className="mt-12 grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
                    <Reveal delay={0.1} className="lg:col-span-7">
                        <p className="t-intro font-normal">
                            Ben Abdü Samed Akgül. iOS ve Android için, çoğunlukla React Native ve Flutter ile mobil uygulamalar ve arkalarındaki Node.js servislerini geliştiriyorum. Son yıllarda mobil ekiplere liderlik ettim, üniversiteler ve girişimler için uygulamalar yayınladım ve kendi yapay zekâ ürünlerimi çıkardım.
                        </p>
                        <p className="t-body mt-6 max-w-[620px] text-ink-600">
                            Bugün bağımsız danışman olarak çalışıyorum: bir ürünü ilk taslaktan mağaza listesine taşıyabilen, gerektiğinde web sitesini, yönetim panelini ya da oyununu da aynı elden ekleyen tek bir muhatap.
                        </p>
                    </Reveal>
                    <Reveal delay={0.2} className="flex flex-col items-start gap-6 lg:col-span-4 lg:col-start-9">
                        <a href={CONTACT_MAILTO} className="btn-pill">İletişime geçin</a>
                        <a href={cv} target="_blank" rel="noopener noreferrer" className="link-arrow">
                            <span className="label">Özgeçmişi görüntüle</span><ArrowIcon className="arrow" />
                        </a>
                    </Reveal>
                </div>
            </section>

            <section className="container-site pt-[96px] md:pt-[140px]">
                {PRINCIPLES.map((item, index) => (
                    <Reveal key={item.n} delay={index * 0.05} className="grid grid-cols-1 gap-4 border-t border-ink-100 py-10 md:grid-cols-12 md:gap-8">
                        <span className="t-eyebrow md:col-span-2">{item.n}</span>
                        <h2 className="t-h3 md:col-span-4">{item.title}</h2>
                        <p className="t-body text-ink-600 md:col-span-6">{item.text}</p>
                    </Reveal>
                ))}
                <div className="border-t border-ink-100" />
            </section>

            <section className="container-site pb-[120px] pt-[96px] md:pt-[140px]">
                <Reveal>
                    <h2 className="t-h2">Teknolojiler</h2>
                    <p className="t-body mt-4 max-w-[640px] text-ink-600">
                        Uçtan uca JavaScript ve TypeScript, Flutter için Dart, REST API'ler, CI/CD ve Git günlük araçlarım.
                    </p>
                </Reveal>
                <Reveal delay={0.1} className="mt-10 flex flex-wrap gap-3">
                    {STACK.map((skill) => (
                        <span key={skill} className="rounded-full border border-ink-200 px-5 py-3 t-small font-medium">{skill}</span>
                    ))}
                </Reveal>
            </section>
        </div>
    )
}

export default About
